export default __webpack_public_path__ + "static/media/iphone_msg_sent.bbfe8b0a.mp3";